const PlatformModel = {};

PlatformModel.ANY = {
  id: 0,
  title: 'Any',
};

PlatformModel.PC = {
  id: 1,
  title: 'PC',
};

PlatformModel.XBOX = {
  id: 2,
  title: 'XBOX',
};

PlatformModel.PLAYSTATION = {
  id: 3,
  title: 'PlayStation',
};

PlatformModel.ANDROID = {
  id: 4,
  title: 'Android',
};

PlatformModel.IOS = {
  id: 5,
  title: 'IOS',
};

PlatformModel.EPICGAMES = {
  id: 6,
  title: 'EpicGames Launcher',
};

PlatformModel.STEAM = {
  id: 7,
  title: 'Steam',
};

PlatformModel.ALTLAUNCHER = {
  id: 8,
  title: 'Launcher',
};

PlatformModel.MOBILE = {
  id: 9,
  title: 'Mobile',
};

PlatformModel.LIST = [
  PlatformModel.PC,
  PlatformModel.XBOX,
  PlatformModel.PLAYSTATION,
  PlatformModel.ANDROID,
  PlatformModel.IOS,
];

PlatformModel.BOOSTER_FILTER_LIST = [
  {
    id: null,
    title: 'Unspecified',
  },
  PlatformModel.PC,
  PlatformModel.XBOX,
  PlatformModel.PLAYSTATION,
  PlatformModel.ANDROID,
  PlatformModel.IOS,
];

PlatformModel.ID_TO_DATA = {
  [PlatformModel.ANY.id]: PlatformModel.ANY,
  [PlatformModel.PC.id]: PlatformModel.PC,
  [PlatformModel.XBOX.id]: PlatformModel.XBOX,
  [PlatformModel.PLAYSTATION.id]: PlatformModel.PLAYSTATION,
  [PlatformModel.ANDROID.id]: PlatformModel.ANDROID,
  [PlatformModel.IOS.id]: PlatformModel.IOS,
  [PlatformModel.EPICGAMES.id]: PlatformModel.EPICGAMES,
  [PlatformModel.STEAM.id]: PlatformModel.STEAM,
  [PlatformModel.ALTLAUNCHER.id]: PlatformModel.ALTLAUNCHER,
};

export default PlatformModel;
